/* eslint-disable */ import { memoEval, replaceEntityRecipesComponent, sceneEntityAddFabComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const nonWallCabinetSegmentComponents = [
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addBlockFab', true).withAlias('NonWallCabinetSegment').withGradualFilter({
        modes: [
            'owner'
        ],
        active: (self)=>self.$isLastSegment
    }).attach(memoEval((self)=>[
            self.$fabRightOffsetX,
            self.$fabOffsetY
        ], ($fabRightOffsetX, $fabOffsetY)=>({
            offsetX: $fabRightOffsetX,
            offsetY: $fabOffsetY,
            offsetZ: 12,
            instanceNames: [
                'baseCabinet',
                'tallCabinet',
                'wallCabinet',
                'noCabinet'
            ],
            skipMenuWhenOnlyOne: false,
            showWhen: [
                'selected',
                'unselected'
            ],
            azimuthAngleLimits: {
                min: -0.1,
                max: 0.5
            }
        }))),
    attachComponent.withComponent(sceneEntityAddFabComponent, 'addBlockFabLeft', true).withAlias('NonWallCabinetSegment').withGradualFilter({
        modes: [
            'owner'
        ],
        active: (self)=>self.$isFirstSegment
    }).attach(memoEval((self)=>[
            self.$fabOffsetY
        ], ($fabOffsetY)=>({
            offsetX: -7,
            offsetY: $fabOffsetY,
            offsetZ: 12,
            instanceNames: [
                'baseCabinetLeft',
                'tallCabinetLeft',
                'wallCabinetLeft',
                'noCabinetLeft'
            ],
            skipMenuWhenOnlyOne: false,
            showWhen: [
                'selected',
                'unselected'
            ],
            azimuthAngleLimits: {
                min: -0.5,
                max: 0.1
            }
        }))),
    attachComponent.withComponent(replaceEntityRecipesComponent, 'default', true).withAlias('NonWallCabinetSegment').attach(memoEval((self)=>[
            self.$replacementRecipes
        ], ($replacementRecipes)=>({
            recipes: $replacementRecipes,
            keepChildren: false
        })))
];

//# sourceMappingURL=non-wall-cabinet-segment.js.map